import { render, staticRenderFns } from "./detalhesPedidoVenda.vue?vue&type=template&id=605de2a9&scoped=true&"
import script from "./detalhesPedidoVenda.vue?vue&type=script&lang=js&"
export * from "./detalhesPedidoVenda.vue?vue&type=script&lang=js&"
import style0 from "./detalhesPedidoVenda.vue?vue&type=style&index=0&id=605de2a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605de2a9",
  null
  
)

export default component.exports